// assets
import logoIcon from 'assets/images/logo-icon.png';

// ==============================|| LOGO ICON - NEXTGEN GTN ||============================== //

export default function LogoIcon() {
  return <img src={logoIcon} alt="NextGen GTN™" style={{ height: 32, width: 32, display: 'block' }} />;
}
